import { useEffect, useState } from "react";
import { readStored, writeStored } from "../toolExperience/storage";
import { normalizePins, pinStorageKey } from "./preferences";
import type { ToolId, WorkspaceScope } from "../toolExperience/types";
const changed = "lazysem:pins-changed";
export function usePinnedTools(scope: WorkspaceScope | null, role?: string) {
  const [, setRevision] = useState(0);
  const key = scope ? pinStorageKey(scope) : "";
  useEffect(() => {
    const update = () => setRevision((r) => r + 1);
    window.addEventListener(changed, update);
    window.addEventListener("storage", update);
    return () => {
      window.removeEventListener(changed, update);
      window.removeEventListener("storage", update);
    };
  }, []);
  const ids = key ? normalizePins(readStored(key, true), role) : [];
  const save = (next: ToolId[]) => {
    if (!key) return;
    writeStored(key, normalizePins(next, role), true);
    window.dispatchEvent(new Event(changed));
  };
  return {
    ids,
    setPinned: (id: ToolId, pinned: boolean) =>
      save(pinned ? [...ids, id] : ids.filter((t) => t !== id)),
    movePin: (id: ToolId, direction: "up" | "down") => {
      const next = [...ids],
        from = next.indexOf(id),
        to = from + (direction === "up" ? -1 : 1);
      if (from < 0 || to < 0 || to >= next.length) return;
      [next[from], next[to]] = [next[to], next[from]];
      save(next);
    },
    reset: () => save(normalizePins(null, role)),
  };
}
